import type React from "react";
import HelpIcon from "~/images/help_black.svg?react";
import styles from "./index.module.scss";

export type TooltipPosition = "top" | "bottom" | "right";

export interface InfoTooltipProps {
  message: string;
  className?: string;
  position?: TooltipPosition;
  children?: React.ReactNode; // optional custom trigger content
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  message,
  className = "",
  position = "top",
  children,
}) => {
  return (
    <div className={`${styles["tooltipWrapper"]} ${className}`}>
      {children ? (
        <button type="button" className={styles["triggerButton"]} aria-label="補足情報を表示">
          {children}
        </button>
      ) : (
        <button type="button" className={styles["iconButton"]} aria-label="補足情報を表示">
          <HelpIcon />
        </button>
      )}
      <div className={`${styles["tooltip"]} ${styles[position]}`}>
        <span className={styles["tooltipText"]}>{message}</span>
      </div>
    </div>
  );
};

export default InfoTooltip;
